class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    this.pageNum = '&page=2'

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      const loadingSpinner = document.getElementsByClassName('custom-page-fully-loaded-spinner')[0];
      loadingSpinner.parentElement.style.textAlign = 'center';
      loadingSpinner.classList.remove('hidden');
      const globalContentLoadingDiv = document.getElementById('ProductGridContainer');
      globalContentLoadingDiv.classList.add('hidden');
      globalContentLoadingDiv.parentElement.parentElement.classList.add('hidden');
      document.getElementsByClassName('footer')[0].style.marginTop = '15px';
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
      var global_product_filter = document.querySelector('[aria-label="Products (0 selected)"]');
      var global_product_checkbox = document.querySelector('input[value="Wargame Trader"]');
      // If we're already filtering by wargame trader products
      if (window.location.href.includes("?filter.p.vendor=Wargame+Trader&")) {
        var activeFilters = document.getElementsByClassName("active-facets");
        var mobileActiveFilters = document.getElementsByClassName("active-facets-mobile");
        var mobileProductFilter = document.getElementById(document.querySelector('[id^="Details-Mobile-filter.p.vendor-template--"]').id);
        var global_product_filter = document.querySelector('[aria-label="Products (1 selected)"]');
        global_product_filter.style.display = "none";
        global_product_filter.parentElement.style.marginRight = '0px';
        if (mobileProductFilter) {
          mobileProductFilter.style.display = "none";
        }
        var url = window.location.href;
        url = url.includes("?filter.p.vendor=Wargame+Trader&") ? 
          url : url.replace("?", "?filter.p.vendor=Wargame+Trader&");
        FacetFiltersForm.updateCardData();
        activeFilters[activeFilters.length - 2].style.display = "none";
        mobileActiveFilters[mobileActiveFilters.length - 1].style.display = "none";
      } else {
        if (global_product_checkbox) {
            global_product_checkbox.click();
        } else {
          setTimeout(function (){
            var global_product_checkbox = document.querySelector('input[value="Wargame Trader"]');
            global_product_checkbox.click();
          }, 600);
        }
      }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, pageParam='') {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}${pageParam}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

    static updateCardData() {
        const loadingSpinner = document.getElementsByClassName('custom-page-fully-loaded-spinner')[0];
        const globalContentLoadingDiv = document.getElementById('ProductGridContainer');
        
        const allowedSortOptions = ["title-descending", "title-ascending", "created-ascending", "created-descending", "relevance"];
        [...[...document.getElementsByClassName("facet-filters__sort")][0].options].forEach(option => {
          if (!allowedSortOptions.includes(option.value)) {
            option.remove();
          }
        });
        const mobileSort = document.getElementById("SortBy-mobile");
       if (mobileSort) {
         [...mobileSort.options].forEach(option => {
            if (!allowedSortOptions.includes(option.value)) {
              option.remove();
            }
          });
        }
        fetch("/browsing_context_suggestions.json")
        .then(response => response.json())
        .then(data => {
          const country = data.detected_values.country.name;
          const countryCode = data.detected_values.country.handle;

          // Remove all non-matching country filters
          let countryFiltersToRemove = ["united_states", "united_kingdom", "canada"].filter(countryFilterName => !(country.replace(/ /g, '_').toLowerCase() === countryFilterName));
          countryFiltersToRemove.forEach(filter => {
              const filterElement = [...document.querySelectorAll(`details[id^="Details-filter.p.m.custom.${filter}_in_stock"]`)][0];
              if (filterElement) {
                filterElement.remove();
              }
              const mobileFilterElement = [...document.querySelectorAll(`details[id^="Details-Mobile-filter.p.m.custom.${filter}_in_stock"]`)][0];
              if (mobileFilterElement) {
                mobileFilterElement.remove();
              }
          });
          // Remove the out of stock availability filter from the one country in stock filter remaining, since we only care about in-stock.
          const stockFilter = [...document.querySelectorAll(`details[id^="Details-filter.p.m.custom.${country.replace(/ /g, '_').toLowerCase()}_in_stock"]`)][0];
          if (stockFilter) {
            const outOfStockFilter = stockFilter.querySelectorAll('input[value="0"]')[0];
            if (outOfStockFilter) {
              outOfStockFilter.parentElement.parentElement.remove();
            }
            // Then update the stock filter to say "none" if there's nothing left.
            if (stockFilter.getElementsByTagName('input').length === 0) {
              stockFilter.lastElementChild.innerHTML = "<p style=\"font-size: 12px; font-weight: bold;\">None</p>";
            }
          }

          let mobileStockFilter = [...document.querySelectorAll(`details[id^="Details-Mobile-filter.p.m.custom.${country.replace(/ /g, '_').toLowerCase()}_in_stock"]`)][0];
          if (mobileStockFilter) {
            const mobileOutOfStockFilter = mobileStockFilter.querySelectorAll('input[value="0"]')[0];
            if (mobileOutOfStockFilter) {
              mobileOutOfStockFilter.parentElement.parentElement.remove();
            }
            // Then update the stock filter to say "none" if there's nothing left.
            if (mobileStockFilter.getElementsByTagName('input').length === 0) {
              mobileStockFilter.lastElementChild.innerHTML = "<p style=\"font-size: 12px; font-weight: bold;\">None</p>";
            }
          }


          const cardWrappers = document.getElementsByClassName("product-card-wrapper");
          [...cardWrappers].forEach(cardWrapper => {
            const productDescription = cardWrapper.id;
            const getSellerProductDataUrl = `https://www.wargametrader.com/search?&q="${productDescription.replace(/ /g, '+').replace(/&/g, "%26")}"&country=${country}`;
            const originalCardProduct = document.getElementById(productDescription);
            const originalCardHref = originalCardProduct.getElementsByTagName('a')[0].href;
            const originalImage = originalCardProduct.getElementsByTagName('img')[0];
            let totalListingsCount = 0;
              fetch(getSellerProductDataUrl)
                .then((sellerResponse) => sellerResponse.text())
                .then((sellerResponseText) => {
                  const sellerHtml = sellerResponseText;
                  let lowestPrice = null;
                  const updatedCardWrappers = new DOMParser().parseFromString(sellerHtml, 'text/html').getElementsByClassName("product-card-wrapper");
                  [...updatedCardWrappers].forEach(updatedCardWrapper => {
                    const priceDiv = updatedCardWrapper.getElementsByClassName("price-item--regular")[0];
                    if (updatedCardWrapper.getElementsByClassName('badge--bottom-left').length === 0 && priceDiv && priceDiv.innerText.length > 1 && productDescription.replace(/  /g, " ") === updatedCardWrapper.id.replace(/  /g, " ")) {
                      const price = parseFloat(priceDiv.innerText.replace(/[^\d.]+/g, ''));
                      totalListingsCount = totalListingsCount + 1;
                      if (originalCardProduct !== null) {
                        if (lowestPrice === null || price < lowestPrice) {
                            lowestPrice = price;
                            originalCardProduct.innerHTML = updatedCardWrapper.innerHTML;
                            [...originalCardProduct.getElementsByTagName('a')].forEach(cardLink => {
                              cardLink.href = originalCardHref;
                            });
                            [...originalCardProduct.getElementsByTagName('img')].forEach(image => {
                              image.src = originalImage.src;
                              image.srcset = originalImage.srcset;
                            });
                          }
                      }
                    }
                  });
                  if (totalListingsCount > 0) {
                    const cardPrice = [...cardWrapper.getElementsByClassName("regularFromPrice")][0];
                    if (cardPrice) {
                      cardPrice.innerText = `${totalListingsCount}+ Listing${totalListingsCount > 1 ? 's From' : ' At'} ${cardPrice.innerText}`;                  
                    }
                  }
                  loadingSpinner.classList.add('hidden');
                  globalContentLoadingDiv.classList.remove('hidden');
                  globalContentLoadingDiv.parentElement.parentElement.classList.remove('hidden');
                  document.getElementsByClassName('footer')[0].style.marginTop = '0px';
                });
            });
        });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        FacetFiltersForm.updateCardData();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    FacetFiltersForm.updateCardData();
  }

  static renderProductGridContainer(html) {
    // If we're already filtering by wargame trader products
    var activeFilters = document.getElementsByClassName("active-facets");
    var mobileActiveFilters = document.getElementsByClassName("active-facets-mobile");
    const mobileProductFilterQuery = '[id*="Details-Mobile-filter.p.vendor-template"]';
    if (!window.location.href.includes("?filter.p.vendor=Wargame+Trader&")) {
        var global_product_filter = document.querySelector('[aria-label="Products (1 selected)"]');
        if (!global_product_filter) {
            var global_product_checkbox = document.querySelector('input[value="Wargame Trader"]');
            global_product_checkbox.click();
          return;
        }
        var mobileProductFilter = document.querySelector(mobileProductFilterQuery);
        global_product_filter.style.display = "none";
        global_product_filter.parentElement.style.marginRight = '0px';
        if (mobileProductFilter) {
          mobileProductFilter.style.display = "none";
        }
        activeFilters[activeFilters.length - 2].style.display = "none";
        mobileActiveFilters[mobileActiveFilters.length - 1].style.display = "none";
    } else {
      var global_product_filter = document.querySelector('[aria-label="Products (1 selected)"]');
      var mobileActiveFilters = document.getElementsByClassName("active-facets-mobile");
      if(activeFilters && global_product_filter) {
        var mobileProductFilter = document.querySelector(mobileProductFilterQuery);
        global_product_filter.style.display = "none";
        global_product_filter.parentElement.style.marginRight = '0px';
        
        if (mobileProductFilter) {
          mobileProductFilter.style.display = "none";
        }
        activeFilters[activeFilters.length - 2].style.display = "none";
        mobileActiveFilters[mobileActiveFilters.length - 1].style.display = "none";
      }
    }
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    const pageParamRegex = /&page=\d+/g;
    const pageParamArray = window.location.href.match(pageParamRegex);
    let pageParam = '';

    if (pageParamArray && event.target.id.includes('Filter-filter.p.vendor-')) {
      pageParam = pageParamArray[0];
    }
    FacetFiltersForm.renderPage(searchParams, event, false, pageParam);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
